import { Typography } from '@mui/material';

export const FieldDesc = ({
  children,
  className,
  textClassName,
}: {
  children: React.ReactNode;
  className?: string;
  textClassName?: string;
}) => {
  return (
    <div className={'opacity-50 mb-2 ' + className}>
      <Typography variant="subtitle1" className={textClassName}>
        {children}{' '}
      </Typography>
    </div>
  );
};
